import { DataObject } from '@shared/models/data-object.model';

export type MessageCenterStateModel = MessageItem[];

export const enum MessageItemType {
  error = 'error',
  warning = 'warning',
  info = 'info',
  queue = 'queue',
  misc = 'misc',
}

export enum MessageItemLevel {
  sections = 'sections',
  columns = 'columns',
  record = 'record',
}

export interface MessageItem {
  type: MessageItemType;
  level?: MessageItemLevel;
  message?: string;
  identifier?: KeyIdentifier;
  id?: number;
  code?: string;
  params?: DataObject;
}

export enum SingleMessageClass {
  Warning = 'warning',
}

export enum KeyIdentifier {
  SplitReview = 'splitReview',
}
